import { render, staticRenderFns } from "./AppDropzone.vue?vue&type=template&id=81fff852&"
import script from "./AppDropzone.vue?vue&type=script&lang=ts&"
export * from "./AppDropzone.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports